import React, { useState } from 'react';
import classnames from 'classnames';
import { ThemeOptions, ThemeSkin } from '@wix/da-react-context/pkg/constants';
import { useTranslation } from 'react-i18next';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import ThemeSwitchDark from '@wix/da-ds/pkg/Icons/ThemeSwitchDark/ThemeSwitchDark';
import ThemeSwitchLight from '@wix/da-ds/pkg/Icons/ThemeSwitchLight/ThemeSwitchLight';
import ThemeSwitchGreen from '@wix/da-ds/pkg/Icons/ThemeSwitchGreen/ThemeSwitchGreen';
import { BiData } from '@wix/da-bi/pkg/events';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import userDropdownStyles from '../UserMenuDesktop.scss';
export default (({ theme, setTheme, themeSkin, setThemeSkin })=>{
    const [currentTheme, setCurrentTheme] = useState(theme);
    const [currentThemeSkin, setCurrentThemeSkin] = useState(themeSkin);
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: userDropdownStyles['two-side-label']
    }, /*#__PURE__*/ React.createElement("span", null, t('siteHeader.userMenu.mode')), /*#__PURE__*/ React.createElement("span", {
        className: userDropdownStyles['theme-toggles']
    }, /*#__PURE__*/ React.createElement(BiSpan, {
        title: t('siteHeader.userMenu.themeDark'),
        onClick: ()=>{
            setCurrentThemeSkin(undefined);
            setCurrentTheme(ThemeOptions.DARK);
            yieldToMain(()=>setTheme(ThemeOptions.DARK));
        },
        className: classnames(userDropdownStyles['theme-toggle-item'], currentTheme === ThemeOptions.DARK && !themeSkin && userDropdownStyles['active']),
        biData: BiData({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: 'dark'
        })
    }, /*#__PURE__*/ React.createElement(ThemeSwitchDark, {
        size: IconSize.LARGE
    })), /*#__PURE__*/ React.createElement(BiSpan, {
        title: t('siteHeader.userMenu.themeLight'),
        onClick: ()=>{
            setCurrentThemeSkin(undefined);
            setCurrentTheme(ThemeOptions.LIGHT);
            yieldToMain(()=>setTheme(ThemeOptions.LIGHT));
        },
        className: classnames(userDropdownStyles['theme-toggle-item'], currentTheme === ThemeOptions.LIGHT && !themeSkin && userDropdownStyles['active']),
        biData: BiData({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: 'light'
        })
    }, /*#__PURE__*/ React.createElement(ThemeSwitchLight, {
        size: IconSize.LARGE
    })), /*#__PURE__*/ React.createElement(BiSpan, {
        title: t('siteHeader.userMenu.themeGreen'),
        onClick: ()=>{
            setCurrentTheme(ThemeOptions.LIGHT);
            setCurrentThemeSkin(ThemeSkin.GREEN);
            yieldToMain(()=>setThemeSkin(ThemeSkin.GREEN));
        },
        className: classnames(userDropdownStyles['theme-toggle-item'], currentThemeSkin === ThemeSkin.GREEN && userDropdownStyles['active']),
        biData: BiData({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: 'green'
        })
    }, /*#__PURE__*/ React.createElement(ThemeSwitchGreen, {
        size: IconSize.LARGE
    }))));
});

//# sourceMappingURL=ThemeSwitcherButtons.js.map